import OperatorAddParams from "../../../../../../common/services/operator/add/operator-add-params";
import OperatorAddFormData from "./operator-add-form-data";

const create = (formData: OperatorAddFormData): OperatorAddParams => {
  return {
    alternativePhoneNumber: formData.alternativePhoneNumber,
    email: formData.email,
    firstName: formData.firstName,
    lastName: formData.lastName,
    password: formData.password,
    phoneNumber: formData.phoneNumber,
    username: formData.username,
  };
};

const operatorAddParamsFactory = {
  create,
};

export default operatorAddParamsFactory;
